var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComponents = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "component copy 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M19.1897 15.6818C18.3738 15.6818 17.6288 15.1344 17.4097 14.3073L15.1812 5.86027C14.9215 4.87443 15.5072 3.86366 16.4907 3.60335C17.476 3.3412 18.4816 3.93012 18.7422 4.91596L20.9707 13.363C21.2303 14.3489 20.6447 15.3597 19.6612 15.62C19.5037 15.6615 19.3453 15.6818 19.1897 15.6818Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M13.8064 21.0799C13.6508 21.0799 13.4924 21.0605 13.334 21.0181L4.90808 18.7833C3.92551 18.5221 3.33892 17.5122 3.59861 16.5264C3.85829 15.5415 4.86203 14.9498 5.85012 15.2138L14.276 17.4485C15.2586 17.7098 15.8452 18.7196 15.5855 19.7055C15.3682 20.5335 14.6223 21.0799 13.8064 21.0799Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M46.5061 36.848C46.3505 36.848 46.1921 36.8286 46.0337 36.7862L37.6078 34.5514C36.6252 34.2902 36.0386 33.2803 36.2983 32.2945C36.558 31.3095 37.5608 30.7178 38.5498 30.9818L46.9757 33.2166C47.9583 33.4778 48.5449 34.4877 48.2852 35.4735C48.0669 36.3015 47.322 36.848 46.5061 36.848Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M34.9202 48.4593C34.1043 48.4593 33.3593 47.9119 33.1401 47.0848L30.9117 38.6387C30.652 37.6528 31.2376 36.642 32.2211 36.3817C33.2074 36.1187 34.212 36.7085 34.4726 37.6944L36.7011 46.1405C36.9608 47.1264 36.3751 48.1371 35.3917 48.3974C35.2342 48.439 35.0758 48.4593 34.9202 48.4593Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M36.3601 29.1513C35.8886 29.1513 35.418 28.9713 35.058 28.6104C34.3388 27.8895 34.3388 26.7209 35.058 25.999L46.7419 14.2889C47.4611 13.5689 48.6269 13.568 49.3461 14.2889C50.0653 15.0098 50.0653 16.1784 49.3461 16.9003L37.6622 28.6113C37.3021 28.9713 36.8306 29.1513 36.3601 29.1513Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M48.0431 17.4422C47.5717 17.4422 47.1011 17.2622 46.741 16.9012L35.0194 5.1514C34.3002 4.43047 34.3002 3.26186 35.0194 2.54094C35.7386 1.82001 36.9044 1.82001 37.6236 2.54094L49.3452 14.2908C50.0644 15.0117 50.0644 16.1803 49.3452 16.9012C48.9852 17.2612 48.5146 17.4422 48.0431 17.4422Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M24.6403 17.4034C24.1688 17.4034 23.6983 17.2234 23.3382 16.8625C22.619 16.1416 22.619 14.9729 23.3382 14.252L35.0194 2.54094C35.7386 1.82001 36.9044 1.82001 37.6236 2.54094C38.3428 3.26186 38.3428 4.43047 37.6236 5.1514L25.9424 16.8625C25.5824 17.2225 25.1118 17.4034 24.6403 17.4034Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M15.5617 50.0001C15.0902 50.0001 14.6197 49.8201 14.2596 49.4592C13.5404 48.7382 13.5404 47.5696 14.2596 46.8487L25.9426 35.1376C26.6618 34.4167 27.8276 34.4167 28.5468 35.1376C29.266 35.8585 29.266 37.0272 28.5468 37.7481L16.8638 49.4592C16.5038 49.8201 16.0323 50.0001 15.5617 50.0001Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M15.5613 49.9999C15.0898 49.9999 14.6193 49.8199 14.2592 49.459L2.5394 37.711C1.8202 36.99 1.8202 35.8214 2.5394 35.1005C3.25859 34.3796 4.4244 34.3796 5.1436 35.1005L16.8634 46.8494C17.5826 47.5704 17.5826 48.739 16.8634 49.4599C16.5034 49.8199 16.0319 49.9999 15.5613 49.9999Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M3.8415 38.2511C3.37001 38.2511 2.89945 38.0711 2.5394 37.7101C1.8202 36.9892 1.8202 35.8206 2.5394 35.0997L14.2215 23.3886C14.9407 22.6677 16.1065 22.6677 16.8257 23.3886C17.5449 24.1095 17.5449 25.2781 16.8257 25.9991L5.1436 37.7111C4.78354 38.0711 4.31298 38.2511 3.8415 38.2511Z",
    fill: "#4A4A4A",
    stroke: "#979797",
    strokeWidth: 0.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponents);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/components.ac0bd0480aab5a30725686a7746ac005.svg";